/**
 * @author Madhu.sudhan
 * @Date: 2022-11-21 15:05:58
 * @Last Modified by: madhusudhan
 * @Last Modified time: 2022-11-22 15:05:58
 */
import React, { Fragment } from 'react';
import { Button, Form, Input, Select } from 'antd';
import { validationRules } from '../../devUtils';
import { NsdlFundTransferPropTypes } from './FundTransferDatahandler';

const { TextArea } = Input;
const { Option } = Select;

function TransferFormNsdl(props) {
  const { isLoadingStatus,
    form: { getFieldDecorator },
    NsdlFundTransfer: { beneficiaries: { account_number, id } = {} },
    otherParams,
    handleModal,
  } = props;
  return (
    <Fragment>
      <h2>Transfer Fund</h2>
      <Form.Item className="margin-b-1">
        {getFieldDecorator('id', {
          initialValue: id || otherParams.id,
        })}
      </Form.Item>
      <Form.Item className="margin-b-1" label="Account Number">
        {getFieldDecorator('account_number', {
          initialValue: account_number || otherParams.account_number,
        })(
          <Input placeholder="Please Enter Account Number" disabled />
        )}
      </Form.Item>
      <Form.Item className="margin-b-1" label="Amount">
        {getFieldDecorator('imps_txn_amt', {
          rules: [validationRules.amount_field],
        })(
          <Input placeholder="Please Enter Amount" />
        )}
      </Form.Item>
      <Form.Item className="margin-b-1" label="Remarks">
        {getFieldDecorator('imps_payer_remarks', {
          rules: [validationRules.mandatory],
        })(
          <TextArea rows={2} placeholder="Enter remarks" />
        )}
      </Form.Item>
      <div className="text-right">
        <Button className="white-btn" onClick={handleModal}>
            Cancel
        </Button>
        <Button
          htmlType="submit"
          className="green-btn margin-l-1"
          loading={isLoadingStatus}
        >Transfer
        </Button>
      </div>
    </Fragment>
  );
}

function AddEditFormNsdl(props) {
  const { isLoadingStatus,
    form: { getFieldDecorator },
    NsdlFundTransfer: { beneficiaries: { name, account_number, account_type, ifsc_code } = {} },
    type,
    otherParams,
    handleModal,
  } = props;
  return (
    <div>
      <h2>{type === 'EDIT_LIMIT' ? 'Edit' : 'Add New'} Beneficiary </h2>
      <Form.Item label="Account Type">
        {getFieldDecorator('account_type', {
          rules: [validationRules.mandatory],
          initialValue: account_type || otherParams.account_type,
        })(
          <Select
            placeholder="Select Account Type"
          >
            <Option key="savings" value="savings">Savings</Option>
            <Option key="current" value="current">Current</Option>
            <Option key="overdraft" value="overdraft">OverDraft</Option>
          </Select>
        )}
      </Form.Item>
      <Form.Item className="margin-b-1" label="Account Holder Name">
        {getFieldDecorator('name', {
          rules: [validationRules.mandatory],
          initialValue: name || otherParams.name,
        })(
          <Input placeholder="Please enter account holder name" maxLength={20} />
        )}
      </Form.Item>
      <Form.Item className="margin-b-1" label="Account Number">
        {getFieldDecorator('account_number', {
          rules: [validationRules.number_manadatory],
          initialValue: account_number || otherParams.account_number,
        })(
          <Input placeholder="Please enter account number" />
        )}
      </Form.Item>
      <Form.Item className="margin-b-1" label="IFSC Code">
        {getFieldDecorator('ifsc_code', {
          rules: [validationRules.mandatory],
          initialValue: ifsc_code || otherParams.ifsc_code,
        })(
          <TextArea rows={1} placeholder="Please enter IFSC code" />
        )}
      </Form.Item>
      <div className="text-right">
        <Button className="white-btn" onClick={handleModal}>
            Cancel
        </Button>
        <Button
          htmlType="submit"
          className="green-btn margin-l-1"
          loading={isLoadingStatus}
        >{type === 'EDIT_LIMIT' ? 'Submit' : 'Add Beneficiary'}
        </Button>
      </div>
    </div>
  );
}

TransferFormNsdl.propTypes = NsdlFundTransferPropTypes;
AddEditFormNsdl.propTypes = NsdlFundTransferPropTypes;

export { TransferFormNsdl, AddEditFormNsdl };



// WEBPACK FOOTER //
// client/containers/FundTransfer/NsdlFundTransfer.jsx